module.exports = __webpack_public_path__ + "img/dominica.e4609012.svg";